import _ from 'lodash';
import { Member } from 'modules/overlay-v2/domain/interfaces/game-info/gameInfoMapped';
import { Teams } from 'modules/overlay-v2/domain/interfaces/game-info/state';
import { MatchEvent } from 'shared/types/match-event';

interface IOptions {
  playerIndex?: number;
  teamReverse?: boolean;
}

function parseInfoEvent(event: MatchEvent, teams?: Teams, options?: IOptions) {
  const { playerIndex = 0, teamReverse = false } = options ?? {};

  if (!event) return { player: undefined, team: undefined, teamPrefix: undefined };
  if (!teams) return { player: undefined, team: undefined, teamPrefix: undefined };

  const isFirst = event.teamId === teams?.first.id;
  const teamPrefix = (isFirst && !teamReverse) || (!isFirst && teamReverse) ? 'first' : ('second' as 'first' | 'second');
  const team = teams?.[teamPrefix];
  const playerId = event.players[playerIndex]?.id;
  const player = _.find(team?.members, { id: playerId }) as Member | undefined;
  return { player, team, teamPrefix };
}

export default parseInfoEvent;
